import { useMemo } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";
import type { SeasonTransformed } from "~types/seasonTransformed.ts";

export const useExtractSeasonFromScopeByCompetitionId = ({ competitionId }: { competitionId?: string }) => {
  const { data: scopeData, isLoading, refetch } = useGetCurrentUserPermissionScope();

  const seasons = useMemo(() => {
    if (!competitionId) return [];

    const { scope, resources } = scopeData || {};

    const seasonsData = resources?.seasons || {};
    const competitionsData = resources?.competitions || {};
    const leagueTree = scope?.leagueTree || [];
    const seasonList: SeasonTransformed[] = [];

    leagueTree.forEach(({ competitions }) => {
      const competition = competitions.find((comp) => comp.competitionId === competitionId);

      if (competition) {
        const competitionName = competitionsData[competitionId]?.nameLocal || "";

        seasonList.push(
          ...competition.seasonIds.map((seasonId) => ({
            ...seasonsData[seasonId],
            competitionName,
          })),
        );
      }
    });

    return seasonList;
  }, [competitionId, scopeData]);

  const competitionName = competitionId ? scopeData?.resources?.competitions?.[competitionId]?.nameLocal : undefined;

  return {
    seasons,
    isLoading,
    refetch,
    competitionName,
  };
};
